import './DashboardFooter.css';

const DashboardFooter = () => (
  <footer className="dashboard-footer">
    <div className="dashboard-footer-inner">
      <span>© 2026 Z<span className="brand-q">o</span>pe<span className="brand-q">o</span></span>
      <span className="dashboard-footer-divider" aria-hidden="true">·</span>
      <a href="/support">Help</a>
      <span className="dashboard-footer-divider" aria-hidden="true">·</span>
      <a href="/status">Status</a>
    </div>
  </footer>
);

export default DashboardFooter;
